(() => {
  const initialize = () => {
    const root = document.querySelector('[data-enrollment]');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const controller = new AbortController();
    const { signal } = controller;
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const lens = root.querySelector('[data-lens]');
    const replay = root.querySelector('.e-replay');
    const photo = root.querySelector('.e-lens-photo');
    const reveal = () => {
      if (reducedMotion.matches || !lens?.isConnected) return;
      lens.classList.remove('is-revealing');
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (!reducedMotion.matches && lens.isConnected) lens.classList.add('is-revealing');
      }));
    };
    const setMotion = () => {
      if (replay) replay.hidden = reducedMotion.matches;
      if (reducedMotion.matches) lens?.classList.remove('is-revealing');
    };
    setMotion();
    reducedMotion.addEventListener('change', setMotion, { signal });
    replay?.addEventListener('click', reveal, { signal });
    if (photo?.complete) reveal();
    else photo?.addEventListener('load', reveal, { once: true, signal });


    // Rotate existing, credited student photographs only while the gallery is visible.
    const gallery = root.querySelector('.e-contact-sheet');
    const galleryControls = root.querySelector('[data-gallery-controls]');
    if (gallery && galleryControls) {
      const frames = [...gallery.querySelectorAll('figure')];
      const pool = frames.map(frame => ({ label: frame.querySelector('figcaption span:first-child').textContent.split(' / ')[1], src: frame.querySelector('img').src, srcset: frame.querySelector('img').srcset, alt: frame.querySelector('img').alt, credit: frame.querySelector('figcaption span:last-child').textContent }));
      root.querySelectorAll('[data-gallery-extra]').forEach(extra => {
        if (extra.dataset.src) pool.push({ src: extra.dataset.src, srcset: '', alt: extra.dataset.alt, credit: extra.dataset.credit, label: 'STUDENT PHOTOGRAPH' });
      });
      let offset = 0, visible = false, paused = reducedMotion.matches, busy = false;
      const toggle = galleryControls.querySelector('[data-gallery-toggle]');
      const sync = () => { toggle.textContent = paused ? 'Play slideshow' : 'Pause slideshow'; toggle.setAttribute('aria-pressed', String(paused)); };
      const advance = async () => {
        if (busy || signal.aborted) return;
        busy = true;
        const next = (offset + frames.length) % pool.length;
        const selected = frames.map((_, i) => pool[(i + next) % pool.length]);
        try {
          await Promise.all(selected.map(item => new Promise((resolve, reject) => { const image = new Image(); image.onload = resolve; image.onerror = reject; image.srcset = item.srcset; image.sizes = '(max-width:760px) 90vw, 33vw'; image.src = item.src; })));
          if (signal.aborted) return;
          gallery.classList.add('is-changing');
          await new Promise(resolve => setTimeout(resolve, reducedMotion.matches ? 0 : 300));
          if (signal.aborted) return;
          frames.forEach((frame, i) => { const image = frame.querySelector('img'), item = selected[i]; frame.querySelector('figcaption span:first-child').textContent = `0${i + 1} / ${item.label || 'SEE THE DETAIL'}`; image.srcset = item.srcset; image.src = item.src; image.alt = item.alt; frame.querySelector('figcaption span:last-child').textContent = item.credit; });
          offset = next;
        } catch (_) { /* Keep the current photographs if a download fails. */ }
        finally { gallery.classList.remove('is-changing'); busy = false; }
      };
      galleryControls.hidden = false;
      sync();
      toggle.addEventListener('click', () => { paused = !paused; sync(); }, { signal });
      galleryControls.querySelector('[data-gallery-next]').addEventListener('click', () => { paused = true; sync(); advance(); }, { signal });
      reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; sync(); }, { signal });
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; }, { threshold: 0.2 });
      observer.observe(gallery);
      const timer = setInterval(() => { if (visible && !paused && !document.hidden && !gallery.matches(':hover') && !galleryControls.contains(document.activeElement)) advance(); }, 6500);
      signal.addEventListener('abort', () => { clearInterval(timer); observer.disconnect(); }, { once: true });
    }

    // Native details and video controls remain usable without JavaScript.
    // Stop hidden chapter previews and prevent simultaneous audio tracks.
    const videos = [...root.querySelectorAll('video')];
    videos.forEach(video => {
      video.addEventListener('play', () => videos.forEach(other => {
        if (other !== video) other.pause();
      }), { signal });
    });
    root.querySelectorAll('.e-module').forEach(chapter => {
      chapter.addEventListener('toggle', () => {
        if (!chapter.open) chapter.querySelector('video')?.pause();
      }, { signal });
    });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) videos.forEach(video => video.pause());
    }, { signal });
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) controller.abort();
    }, { signal });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
